/**
 * DevExtreme (esm/__internal/core/license/types.js)
 * Version: 23.2.3
 * Build date: Tue Nov 28 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export var TokenKind;
! function(TokenKind) {
    TokenKind.corrupted = "corrupted";
    TokenKind.verified = "verified";
    TokenKind.internal = "internal"
}(TokenKind || (TokenKind = {}));
